"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyPressDocument = exports.useKeyPress = void 0;
var react_1 = require("react");
var useKeyPress = function (targetKey, ref) {
    var _a = (0, react_1.useState)(false), keyPressed = _a[0], setKeyPressed = _a[1];
    var downHandler = function (_a) {
        var key = _a.key;
        if (key === targetKey) {
            setKeyPressed(true);
        }
    };
    var upHandler = function (_a) {
        var key = _a.key;
        if (key === targetKey) {
            setKeyPressed(false);
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', downHandler);
        (_b = ref.current) === null || _b === void 0 ? void 0 : _b.addEventListener('keyup', upHandler);
        return function () {
            var _a, _b;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keyup', upHandler);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('keydown', downHandler);
        };
    });
    return keyPressed;
};
exports.useKeyPress = useKeyPress;
var useKeyPressDocument = function (targetKey) {
    var _a = (0, react_1.useState)(false), keyPressed = _a[0], setKeyPressed = _a[1];
    function downHandler(_a) {
        var key = _a.key;
        if (key === targetKey) {
            setKeyPressed(true);
        }
    }
    var upHandler = function (_a) {
        var key = _a.key;
        if (key === targetKey) {
            setKeyPressed(false);
        }
    };
    (0, react_1.useEffect)(function () {
        document === null || document === void 0 ? void 0 : document.addEventListener('keydown', downHandler);
        document === null || document === void 0 ? void 0 : document.addEventListener('keyup', upHandler);
        return function () {
            document === null || document === void 0 ? void 0 : document.removeEventListener('keyup', upHandler);
            document === null || document === void 0 ? void 0 : document.removeEventListener('keydown', downHandler);
        };
    });
    return keyPressed;
};
exports.useKeyPressDocument = useKeyPressDocument;
